import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

const DeviceRental = () => {
  useEffect(() => {
    Aos.init({ duration: 1200, once: true });
  }, []);

  const rentalDevices = [
    {
      title: "Laptop",
      image: "/servicepages/laptop.jpg",
      desc: "Perfect for developers, designers, and professionals.",
      
    },
    {
      title: "Desktop",
      image: "/servicepages/desktop.jpg",
      desc: "Complete setup with monitor, keyboard, and CPU.",
      
    },
    {
      title: "Workstation",
      image: "/servicepages/workstation.png",
      desc: "High-performance workstations designed for CAD, 3D modeling, video editing, and engineering applications. Reliable and powerful machines for professionals.",
     
    },
    {
      title: "Server",
      image: "/servicepages/server.jpg",
      desc: "Enterprise-grade servers ideal for hosting, virtualization, and large-scale processing. Secure, scalable, and backed by expert support.",
      
    },
  ];

  return (
    <section className="min-h-screen bg-blue-950 py-16 px-4 sm:px-8 lg:px-20">
      <div className="max-w-7xl mx-auto space-y-16">
        {/* Header */}
        <div data-aos="fade-up" className="text-center">
          <h2 className="text-4xl font-bold font-poppins text-sky-400">
            Desktop & Laptop Rental
          </h2>
          <p className="text-lg text-white mt-4 font-inter">
            Rent high-performance devices with full support — flexible plans, no upfront cost.
          </p>
        </div>

        {/* Rental Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {rentalDevices.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition duration-300"
              data-aos="fade-up"
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-5 space-y-2 text-center">
                <h3 className="text-xl font-semibold text-blue-900 font-poppins">
                  {item.title}
                </h3>
                <p className="text-gray-700 text-sm font-inter">{item.desc}</p>
               
                
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center" data-aos="zoom-in">
          <a
            href="/contact"
            className="inline-block mt-10 bg-gray-50 text-blue-950 px-8 py-3 rounded-md font-semibold hover:text-sky-400 transition"
          >
            Talk to Our Experts
          </a>
        </div>
      </div>
    </section>
  );
};

export default DeviceRental;
